import { render, staticRenderFns } from "./TamanioShow.vue?vue&type=template&id=64946c51&"
import script from "./TamanioShow.vue?vue&type=script&lang=js&"
export * from "./TamanioShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports